import { AssetRef, MetaType, Duration, PresentationType } from "../types"
import {
  actionCreatorGuard,
  reducerGuard,
  processActionMeta,
  getArrayReducerGuard
} from "../reducers"

const kind = "block_presentations"

export type BlockPresentation = {
  kind: typeof kind
  version: number
  type: PresentationType
  assets: Array<AssetRef>
  autoprogress: boolean
  durations: Array<Duration>
  meta: MetaType
}

export const reducerAction = {
  meta: actionCreatorGuard<BlockPresentation, MetaType>("meta", kind),
  assets: actionCreatorGuard<BlockPresentation, Array<AssetRef>>(
    "assets",
    kind
  ),
  autoprogress: actionCreatorGuard<BlockPresentation, boolean>(
    "autoprogress",
    kind
  ),
  type: actionCreatorGuard<BlockPresentation, PresentationType>("type", kind),
  durations: actionCreatorGuard<BlockPresentation, Array<Duration>>(
    "durations",
    kind
  )
}

// Type safety to ensure we have a defined action for each property
type ReducerActions = {
  [key in keyof Omit<
    BlockPresentation,
    "kind" | "version"
  >]: (typeof reducerAction)[key][0]
}

// Our exported actions
export const blockPresentationAction = Object.fromEntries(
  Object.entries(reducerAction).map(k => [k[0], k[1][0]])
) as ReducerActions

export const blockPresentationReducer = reducerGuard<BlockPresentation>(kind)
  .case(...reducerAction.meta)
  .case(...reducerAction.assets)
  .case(...reducerAction.autoprogress)
  .case(...reducerAction.type)
  .default((prevState, action: any) => {
    action = processActionMeta(action)

    switch (action?.meta?.prop) {
      case "assets":
        return getArrayReducerGuard<BlockPresentation, AssetRef>(
          kind,
          "assets",
          "AssetRef",
          prevState,
          action
        )

      case "durations":
        return getArrayReducerGuard<BlockPresentation, Duration>(
          kind,
          "durations",
          "Duration",
          prevState,
          action
        )
    }

    return prevState
  })
